type ProjectEditingStep = 'format' | 'option' | 'due' | 'brief' | 'preview' | 'complete' | 'submitted';

export const Steps: ProjectEditingStep[] = ['format', 'option', 'due', 'brief', 'preview', 'complete', 'submitted'];

export const DraftSteps: ReadonlyArray<ProjectEditingStep> = ['format', 'option', 'due', 'brief', 'preview'];

export const StepNames: { [key: string]: ProjectEditingStep } = {
  FORMAT: 'format',
  OPTION: 'option',
  DUE: 'due',
  BRIEF: 'brief',
  PREVIEW: 'preview',
  COMPLETE: 'complete',
  SUBMITTED: 'submitted',
};

export default ProjectEditingStep;
